/// <amd-module name="Build/Admin/Common/Stores/ConfirmationDialogStore" />
import { Store } from "VSS/Reflux/Store";

import { IConfirmationPayload, ConfirmButtonType } from "Build/Admin/Common/Actions/ConfirmationDialogActions";

export interface IConfirmationDialogStoreState<T> {
    isOpen: boolean;
    selectedItem: T | undefined;
    title: string;
    content: string | JSX.Element;
    confirmButtonType: ConfirmButtonType;
    onConfirm?(item: T): void;
    onCancel?(): void;
}

export class ConfirmationDialogStore<T> extends Store {
    public state: IConfirmationDialogStoreState<T>;

    constructor() {
        super("ConfirmationDialogStoreChanged");

        this.state = {
            isOpen: false,
            selectedItem: undefined,
            title: "",
            content: "",
            confirmButtonType: ConfirmButtonType.Confirm
        };
    }

    public showDialog = (payload: IConfirmationPayload<T>) => {
        this.state = {
            isOpen: true,
            selectedItem: payload.selectedItem,
            title: payload.title,
            content: payload.content,
            confirmButtonType: payload.confirmButtonType,
            onConfirm: payload.onConfirm,
            onCancel: payload.onCancel
        };
        this.emitChanged();
    }

    public dismissDialog = () => {
        this.state = {
            isOpen: false,
            selectedItem: undefined,
            title: "",
            content: "",
            confirmButtonType: ConfirmButtonType.Confirm
        };
        this.emitChanged();
    }
}
